// extracted by mini-css-extract-plugin
export default {"content":"brand-miss-match_content__1mYoZ","logo":"brand-miss-match_logo__Dg+sf"};